export default {
      id: "mileage-circle-usage",
      viewBox: "0 0 20 17",
      url: __webpack_public_path__ + "img/icons.svg#mileage-circle",
      toString: function () {
        return this.url;
      }
    }